// extracted by css-extract-rspack-plugin
export default {"baselineDropdown__titleDate":"baselineDropdown__titleDate-MUxwaL","baselineDropdownTitleDate":"baselineDropdown__titleDate-MUxwaL"};